<template>
    <Drawer
        :title="title"
        v-model="isBox"
        width="840"
        :mask-closable="false"
        @on-close="FormReset()"
        class-name="drawer-default"
    >
        <div class="set-scroll-form">
            <Form ref="Forms" :model="Forms" :rules="Rules"  label-position="top">
                <Row :gutter="32">
                    <Col span="24">
                        <Card :bordered="false" dis-hover>
                            <template #title><Icon type="md-radio-button-on" class="text-primary" size="16" /> 入账审批</template>
                            <Row :gutter="32">
                                <Col span="24">
                                    <FormItem label="审批" prop="status" :rules="[{required: true, type:'number', message: '请选择审批结果', trigger: 'change',  transform(value) { return parseInt(value)}}]">
                                        <RadioGroup v-model="Forms.status" type="button" button-style="solid">
                                            <Radio :label="2">未到账</Radio>
                                            <Radio :label="4">已到账</Radio>
                                            <Radio :label="3">驳回申请</Radio>
                                        </RadioGroup>
                                    </FormItem>
                                </Col>
                                <Col span="24" v-if="Forms.status === 3">
                                    <FormItem  label="驳回原因" prop="reject_remark" :rules="[{required: true, message: '请输入驳回原因', trigger: 'blur'}]">
                                        <Input v-model="Forms.reject_remark" type="textarea" :rows="4" clearable placeholder="驳回原因"  />
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row :gutter="32"  v-if="Forms.status === 4">
                                <Col span="8">
                                    <FormItem label="到账金额" prop="get_money" :rules="[{ required: true, type: 'number',  message: '请输入到账金额', trigger: 'blur',  transform(value) { return parseFloat(value)}}]">
                                        <Input v-model="Forms.get_money" type="number" class="width-100" clearable placeholder="如：10000" />
                                    </FormItem>
                                </Col>
                                <Col span="8">
                                    <FormItem label="到账时间" prop="get_date" :rules="[{required: true, type:'date', message: '请选择到账时间', trigger: 'change'}]">
                                        <DatePicker type="date" format="yyyy-MM-dd" v-model="Forms.get_date" placeholder="到账时间" class="width-100"  />
                                    </FormItem>
                                </Col>
                                <Col span="8">
                                    <FormItem label="收款账户" prop="get_bank" :rules="[{required: true, type:'number', message: '请选择收款账户', trigger: 'change',  transform(value) { return parseInt(value)}}]">
                                        <Select v-model="Forms.get_bank" clearable filterable  placeholder="收款账户" class="width-100">
                                            <Option v-for="(item,index) in bankList" :key="index" :value="item.id">{{item.account}}({{item.name}})</Option>
                                        </Select>
                                    </FormItem>
                                </Col>
                                <Col span="24">
                                    <FormItem label="到账凭证" prop="get_voucher" :rules="[{required: true, type:'array', message: '请上传到账凭证', trigger: 'change'}]">
                                        <Upload
                                            :show-upload-list="false"
                                            :action="upload_url"
                                            :headers = "{'token': $store.state.token}"
                                            :format="['jpg','jpeg','png','gif']"
                                            :max-size="10 * 1024"
                                            :on-success="handleSuccess"
                                            :on-format-error="handleFormatError"
                                            :on-exceeded-size="handleMaxSize"
                                            :before-upload="handleBeforeUpload">
                                            <div class="uploads">
                                                <div class="upload-images-icon cursor" v-if="Forms.get_voucher.length < 10">
                                                    <Icon type="md-cloud-upload" size="24" />
                                                    <span>点击上传</span>
                                                </div>
                                                <div class="upload-images" v-for="(item,index) in Forms.get_voucher" :key="index" @click.stop="">
                                                    <img :src="site_url + item">
                                                    <div class="show" @click.stop="PhotoView(site_url + item)">预览</div>
                                                    <div class="del" @click.stop="PhotoDelete(index)"><Icon type="md-close" /></div>
                                                </div>
                                            </div>
                                        </Upload>
                                    </FormItem>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                </Row>
                <Row :gutter="32">
                    <Col span="24">
                        <Card :bordered="false" dis-hover>
                            <template #title><Icon type="md-radio-button-on" class="text-primary" size="16" /> 收款信息</template>
                            <DescriptionList class="show-description-title" title="" :col="2"  layout="vertical">
                                <Description term="项目名称：">
                                    {{detail.project_name}}
                                </Description>
                                <Description term="收款客户：">
                                    {{detail.company}}
                                </Description>
                            </DescriptionList>
                            <DescriptionList class="show-description-title" title="" :col="4"  layout="vertical">
                                <Description term="不含税金额：">
                                    <Tag color="blue">{{detail.money}}</Tag>
                                </Description>
                                <Description term="收款费率：">
                                    <Tag>{{detail.tax_rate}} %</Tag>
                                </Description>
                                <Description term="税费金额：">
                                    <Tag>{{detail.tax_money}}</Tag>
                                </Description>
                                <Description term="含税金额：">
                                    <Tag color="green">{{detail.true_money}}</Tag>
                                </Description>
                                <Description term="申请人：">
                                    {{detail.apply_name}}
                                </Description>
                                <Description term="申请时间：">
                                    {{detail.apply_time}}
                                </Description>
                            </DescriptionList>
                            <DescriptionList class="show-description-title" title="" :col="1"  layout="vertical">
                                <Description term="备注信息：">
                                    {{detail.remark}}
                                </Description>
                            </DescriptionList>
                        </Card>
                    </Col>
                </Row>
            </Form>
            <div class="box-drawer-footer">
                <Button class="mr10" @click="FormReset()">取消</Button>
                <Button type="primary" :loading="$store.state.loading" @click="FormSubmit()">确认审批</Button>
            </div>

            <!-- 预览图片 -->
            <Modal
                v-model="is_view_box"
                title="预览"
                :width="840"
                :mask-closable="true"
                :footer-hide="true"
                @on-cancel="PhotoViewClose()">
                <div class="flex-image-box">
                    <img :src="view_url" class="flex-image-box-show">
                </div>
            </Modal>
        </div>
    </Drawer>
</template>

<script>

import {examineIncome, getIncomeConfig, getIncomeDetail} from "@/apis/income";

export default {
    name: 'IncomeExamine',
    components: {
    },
    emits: ['trueHandler'],
    data () {
        return {
            title : '入账审批',
            isBox : false,
            bankList: [],
            detail: [],
            upload_url : this.$uploadApi,
            site_url : this.$siteApi,
            is_view_box : false,
            view_url : '',
            Forms : {
                id: '',
                status: '',
                reject_remark: '',
                get_money: '',
                get_date: '',
                get_bank: '',
                get_voucher: [],
            },
            Rules : {

            }
        }
    },
    methods: {
        /**
         功能：图片预览
         time: 2025-17-15 10:17:00
         **/
        PhotoView(url){
            if(url){
                this.view_url = url;
                this.is_view_box = true;
            }
        },
        /**
         功能：图片删除
         time: 2025/12/15 10:21
         **/
        PhotoDelete(index){
            let that = this;
            that.Forms.get_voucher.splice(index , 1);
        },
        /**
         功能：
         time: 2025/12/15 11:16
         **/
        handleSuccess(res){
            let that = this;
            if(res.code == 100){
                this.Forms.get_voucher.push(res.data.url);
            }else{
                that.$Message.error({ background: true,duration:3, content: res.msg});
            }
        },
        /**
         功能：
         time: 2025/12/15 11:16
         **/
        handleFormatError(){
            let that = this;
            that.$Message.error({ background: true,duration:3, content: '只支持 jpg | png | gif 文件 ' });
            return false;
        },
        /**
         功能：
         time: 2025/12/15 11:16
         **/
        handleMaxSize(){
            let that = this;
            that.$Message.error({ background: true,duration:3, content: '图片大小不能超出 10M' });
            return false;
        },
        /**
         功能：
         time: 2025/12/15 11:16
         **/
        handleBeforeUpload(){
            let that = this;
            if(that.Forms.get_voucher.length >= 10){
                that.$Message.error({ background: true,duration:3, content: '最多只能上传 10 张图' });
                return false;
            }
            return true;
        },
        /**
         功能：
         time: 2025/12/15 11:16
         **/
        PhotoViewClose(){
            this.is_view_box = false;
            this.view_url = '';
        },
        /**
         功能：
         time: 2025/12/26 14:07
         **/
        GetConfig(){
            let that = this;
            getIncomeConfig().then(e=>{
                that.bankList = e.data.bankList ?? [];
            })
        },
        /**
         功能：
         time: 2025/12/17 16:04
         **/
        GetDetail(id){
            let that = this;
            that.$store.commit('SET_LOADING' , true);
            getIncomeDetail(id).then(e => {
                that.detail = e.data;
            })
        },
        /**
         功能：
         time: 2025/12/17 10:47
         **/
        show(id, project_name){
            this.isBox = true;
            this.title = project_name + ' - 入账审批';
            if(id){
                this.Forms.id = id;
                this.GetDetail(id);
            }
            this.GetConfig();
        },
        /**
         功能：
         time: 2025/12/26 16:14
         **/
        FormSubmit(){
            let that = this;
            this.$refs['Forms'].validate((valid) => {
                if (valid) {
                    that.$store.commit('SET_LOADING' , true);
                    examineIncome(that.Forms).then( e =>{
                        that.$Message.success({ background: true,duration:3, content: e.msg });
                        that.FormReset();
                        that.$emit('trueHandler');
                    })
                }
            })
        },
        /**
         功能：
         time: 2025/12/20 11:54
         **/
        FormReset(){
            this.isBox = false;
            this.title = '入账审批';
            this.$refs['Forms'].resetFields();
            this.Forms = {
                id: '',
                status: '',
                reject_remark: '',
                get_money: '',
                get_date: '',
                get_bank: '',
                get_voucher: [],
            };
            this.bankList = [];
            this.detail = [];
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">

</style>
